import { SettingsState } from "./types";

export function getDefaultState(): SettingsState {
    return {
        allPrefTypes: [],
        allIcons: [],
        allGroups: [],
        allPrefs: [],
        selectedGroup: null
    };
}